export default "__VITE_PUBLIC_ASSET__2e8babe5__"